/**
 * F7. Готовка и праздник: при событии `community.festival` выбрать три
 * ингредиента из шести. Верного ответа нет — только разные тексты по
 * первому выбранному ингредиенту; отношения +2 всегда, и при «пропустить».
 */
import type { Dataset, GamblingLaw } from '@life/data';
import type { Life, MinigameOutcome } from '@life/engine';
import type { MinigameDef } from '../types';
import { nothing } from './common';

export const COOKING_MIN_AGE = 5;
export const COOKING_INGREDIENTS = 6;
export const COOKING_PICKS = 3;
export const COOKING_RELATIONS = 2;

export interface CookingState {
  /** Ключи шести ингредиентов. */
  ingredients: string[];
  picks: number;
}

export type CookingInput = { picks: number[] };

function dish(main: number): MinigameOutcome {
  return { ...nothing(), stats: { relations: COOKING_RELATIONS }, logKey: `minigame.cooking.dish.${main}` };
}

export const cooking: MinigameDef<CookingInput, CookingState> = {
  id: 'cooking',
  section: 'F',
  triggers: [{ kind: 'event', event: 'community.festival' }],
  available(life: Life, _ds: Dataset, _law: GamblingLaw): boolean {
    return life.age >= COOKING_MIN_AGE;
  },
  setup(): CookingState {
    const ingredients: string[] = [];
    for (let i = 0; i < COOKING_INGREDIENTS; i += 1) ingredients.push(`minigame.cooking.ing.${i}`);
    return { ingredients, picks: COOKING_PICKS };
  },
  play(state: CookingState, input: CookingInput, _life: Life): MinigameOutcome {
    const picks = Array.isArray(input.picks) ? input.picks : [];
    const main = picks.find((p) => Number.isInteger(p) && p >= 0 && p < state.ingredients.length);
    return dish(main ?? 0);
  },
  expected(): MinigameOutcome {
    return dish(0);
  },
};
